    /**
     * Created by yz on 2016/7/11.
     */
{
    angular
        .module('utilsModule')
        .filter('printTypeFilter', printTypeFilter)
        .filter('orderStatusFilter', orderStatusFilter)
        .filter('refundReasonFilter', refundReasonFilter)
        .filter('refundStatusFilter', refundStatusFilter)
        .filter('discountFilter', discountFilter)
        .filter('fixNumberFilter', fixNumberFilter)
        .filter('orderStatusRefundFilter', orderStatusRefundFilter)
        .filter('orderStatusRefundCheck', orderStatusRefundCheck)
        .filter('agoTimeFilter', agoTimeFilter);

    function printTypeFilter() {
        return function (item) {
            if (item === undefined) {
                return;
            }

            switch (parseInt(item)) {
                case -1:
                    return '';
                case 0:
                    return '文档打印';
                case 1:
                    return '论文打印';
                default:
                    return item;
            }
        };
    }

    function orderStatusRefundFilter() {
        return function (item) {
            //console.log(item);
            if (item === undefined) {
                return;
            }
            let date = new Date(item);
            // console.log(date);
            let now = new Date();

            let digit=parseInt((now.getTime()-date.getTime())/1000);
            if(digit < 24 * 3600){
                return '(24小时内可申请退款)';
            }
            return '(打印超过24小时)';
        };
    }

    function orderStatusRefundCheck() {
        return function (item) {
            //console.log(item);
            if (item === undefined) {
                return;
            }
            let date = new Date(item);
            // console.log(date);
            let now = new Date();

            let digit=parseInt((now.getTime()-date.getTime())/1000);
            if(digit < 24 * 3600){
                return 1;
            }
            return 0;
        };
    }

    //1:待支付
    // 5:待打印
    // 2:已打印？
    // 3:已取消
    // 4:已打印
    // 6:退款
    function orderStatusFilter() {
        return function (item) {
            if (item === undefined) {
                return;
            }
            switch (parseInt(item)) {
                case 1:
                    return '待支付';
                case 5:
                    return '待打印';
                case 2:
                    return '已打印';
                case 3:
                    return '已取消';
                case 4:
                    return '已打印';
                case 6:
                    return '退款';
                default:
                    return item;
            }
            
            
        };
    }
    
    // "参数设置错误",
    // "不想打印",
    // "价格不合理",
    // "无法找到网点",
    // "终端机无法操作",
    // "其他"
    function refundReasonFilter() {
        return function (item) {
            if (item === undefined) {
                return;
            }
            switch (parseInt(item)) {
                case 1:
                    return '参数设置错误';
                case 2:
                    return '不想打印';
                case 3:
                    return '价格不合理';
                case 4:
                    return '无法找到网点';
                case 5:
                    return '终端机无法操作';
                case 6:
                    return '其他';
                default:
                    return item;
            }
            
            
        };
    }

    // 退款状态，refundresp，也是数值
    // 1、申请退款
    // 2、允许退款
    // 3、拒绝退款
    function refundStatusFilter() {
        return function (item) {
            if (item === undefined) {
                return;
            }
            switch (parseInt(item)) {
                case 1:
                    return '退款审核中';
                case 2:
                    return '退款成功(1-3工作日到账，请留意查收)';
                case 3:
                    return '退款失败';
                default:
                    return item;
            }
            
            
        };
    }

    function discountFilter() {
        return function (item) {
            if (item === undefined) {
                return;
            }
            let discount = parseFloat(item)/100;
            if (discount === 0) {
                return '0折';
            }
            if (discount > 0 && discount < 1) {
                discount = discount.toFixed(2);
                /*let str = discount.toString().split('.')[1];
                if (str[1] === '0') {
                    str = str.substr(0, 1);
                }*/
                let str = (discount*10).toString();//2017.9.12修改，之前显示折扣有75折
                return str + '折';
            } 
            if ( discount = 1){
                return '无折扣';
            
            }
            console.log("item:",item);
            return item;
        };
    }
    function fixNumberFilter() {
        return function (item, num) {
            if (item === undefined) {
                return;
            }
            let number = parseFloat(item);
            return number.toFixed(num ? num : 2);
        };
    }
    
    function agoTimeFilter() {
        return function (item) {
            //console.log(item);
            if (item === undefined) {
                return;
            }
            let date = new Date(item);
            // console.log(date);
            let now = new Date();

            let digit=parseInt((now.getTime()-date.getTime())/1000);
            let suffix='秒前';
            //let yestoday = new Date().setDate(now.getDate()-1);
            if(digit>=60){
                digit=parseInt(digit/60);
                suffix='分钟前';
                if(digit>=60){
                    digit=parseInt(digit/60);
                    suffix='小时前';
                    
                    if(digit>=24){
                        digit=parseInt(digit/24);
                        suffix='天前';
                    }
                }
            }
            return digit+suffix;
        }
    }
    
    

}